import React from 'react';

const PageTitle = ({ title }) => (
	<h3>
		{title}
	</h3>
)

export default PageTitle;



// WEBPACK FOOTER //
// ./src/fw/components/pageTitle/PageTitle.js